import styled from "styled-components";

export const Wrapper = styled.div`
  border: 1px solid #e7e5e4;
  height: 100%;

  .card-title {
    font-size: 18px;
    font-weight: 700;
  }

  .snapshot-details {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .snapshot-row {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #212b36;
    line-height: 22px;

    .label {
      font-weight: 600;
    }

    .value {
      font-weight: 600;
      text-align: right;
    }
  }
`;
